import { UserView } from '@pages/user-view/user-view-routes.names';

export const AppointmentFlow = 'appointment-flow';
export const UserViewAppointmentsFlow = `/${UserView}/${AppointmentFlow}`;
